import { render, staticRenderFns } from "./elementPreviewV2.vue?vue&type=template&id=c32d099e"
import script from "./elementPreviewV2.vue?vue&type=script&lang=js"
export * from "./elementPreviewV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports